import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromReducer from './messages.reducer';

export const MESSAGES_STORE_KEY = 'MESSAGES_STORE';
export const getMessagesState =
  createFeatureSelector<fromReducer.MessagesState>(MESSAGES_STORE_KEY);

export const getState = createSelector(getMessagesState, (state) => state);

export const getFilteredItems = createSelector(
  getState,
  (state) => state.filteredItems
);

export const getFilteredSources = createSelector(
  getState,
  (state) => state.filteredSources
);

export const getSelectedId = createSelector(
  getState,
  (state) => state.selectedId
);

export const getSorting = createSelector(getState, (state) => state.sorting);
